"use client";

import { motion, useScroll, useTransform } from "framer-motion";

export function SmoothCursor() {
  return null; // Cursor effects can impact performance, keeping simple for now
}

export function PageTransition({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
}

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <motion.div
      className="pointer-events-none fixed left-0 right-0 top-16 z-40 h-[2px] origin-left bg-accent md:top-[4.5rem] lg:top-[5.5rem]"
      style={{ scaleX }}
      aria-hidden
    />
  );
}
